// import { TEAM_NAME_FORMAT_TYPES } from "@/athleteCompSched/athletecompsched-models";
import {
  TEAM_NAME_FORMAT_TYPES,
  IEventTeam,
} from "../../athletecompsched-models";
import { IEntity } from "../../..//config/config-app-models";
import { IClubCompInfo } from "../../../entry/v2/schools/clubCompInfo-models";
import { IEventTeamHeader } from "../event-teams-models";

export function getDefaultTeamNameFormat() {
  return (
    TEAM_NAME_FORMAT_TYPES.ENTITY +
    " " +
    TEAM_NAME_FORMAT_TYPES.AREA +
    " " +
    TEAM_NAME_FORMAT_TYPES.CLUB +
    " " +
    TEAM_NAME_FORMAT_TYPES.EVENT_GROUP +
    " " +
    TEAM_NAME_FORMAT_TYPES.EVENT +
    " " +
    TEAM_NAME_FORMAT_TYPES.GENDER +
    " " +
    TEAM_NAME_FORMAT_TYPES.AGE_GROUP
  );
}

// a function that returns an exmaple team name based on the team name format
export function getExampleTeamName(teamNameFormat: string) {
  // Add defensive programming - handle undefined or null teamNameFormat
  if (!teamNameFormat) {
    console.warn("getExampleTeamName called with undefined/null teamNameFormat, using default format");
    teamNameFormat = getDefaultTeamNameFormat();
  }
  
  return teamNameFormat
    .replace(
      TEAM_NAME_FORMAT_TYPES.ENTITY,
      teamNameFormat.includes(TEAM_NAME_FORMAT_TYPES.ENTITY)
        ? "Dublin A.C."
        : ""
    )
    .replace(
      TEAM_NAME_FORMAT_TYPES.AREA,
      teamNameFormat.includes(TEAM_NAME_FORMAT_TYPES.AREA) ? "Leinster" : ""
    )
    .replace(
      TEAM_NAME_FORMAT_TYPES.CLUB,
      teamNameFormat.includes(TEAM_NAME_FORMAT_TYPES.CLUB) ? "Dublin A.C." : ""
    )
    .replace(
      TEAM_NAME_FORMAT_TYPES.EVENT,
      teamNameFormat.includes(TEAM_NAME_FORMAT_TYPES.EVENT) ? "4 x 100" : ""
    )
    .replace(
      TEAM_NAME_FORMAT_TYPES.EVENT_GROUP,
      teamNameFormat.includes(TEAM_NAME_FORMAT_TYPES.EVENT_GROUP)
        ? "4 x 100 boys"
        : ""
    )
    .replace(
      TEAM_NAME_FORMAT_TYPES.GENDER,
      teamNameFormat.includes(TEAM_NAME_FORMAT_TYPES.GENDER) ? "Male" : ""
    )
    .replace(
      TEAM_NAME_FORMAT_TYPES.AGE_GROUP,
      teamNameFormat.includes(TEAM_NAME_FORMAT_TYPES.AGE_GROUP)
        ? "Under 15"
        : ""
    );
}

/**
 * Simplified version of getTeamName that generates a team name based on the team name format
 * and available data from event header, user entity, and club info.
 */
export function getTeamName(
  eventTeamHeader: IEventTeamHeader,
  userEntity: IEntity,
  clubCompInfo?: IClubCompInfo | null
): string {
  let teamName = "";

  // Get the team name format - either custom from event team options or default
  const eventTeam: IEventTeam = getEventTeamOptions(eventTeamHeader);
  let teamNameFormat: string = getDefaultTeamNameFormat();

  if (
    eventTeam &&
    eventTeam.teamNameFormat !== undefined &&
    eventTeam.teamNameFormat !== null
  ) {
    teamNameFormat = eventTeam.teamNameFormat;
  }

  if (teamNameFormat.length > 0) {
    teamName = teamNameFormat;

    // Replace entity placeholder with user entity name or club name
    let entity = "";
    if (userEntity && userEntity.entityName.length > 0) {
      entity = userEntity.entityName + " - " + userEntity.name;
    }
    if (clubCompInfo && clubCompInfo.configData.clubName.length > 0) {
      entity = clubCompInfo.configData.clubName;
    }
    teamName = teamName.replace(TEAM_NAME_FORMAT_TYPES.ENTITY, entity);

    // Replace event name placeholder
    teamName = teamName.replace(
      TEAM_NAME_FORMAT_TYPES.EVENT,
      eventTeamHeader.eventName
    );

    // Replace event group placeholder if available
    if (eventTeamHeader.eventGroup && eventTeamHeader.eventGroup.name) {
      teamName = teamName.replace(
        TEAM_NAME_FORMAT_TYPES.EVENT_GROUP,
        eventTeamHeader.eventGroup.name
      );
    } else {
      teamName = teamName.replace(TEAM_NAME_FORMAT_TYPES.EVENT_GROUP, "");
    }

    // Replace gender placeholder
    if (eventTeamHeader.gender === "O") {
      teamName = teamName.replace(TEAM_NAME_FORMAT_TYPES.GENDER, "");
    } else {
      teamName = teamName.replace(
        TEAM_NAME_FORMAT_TYPES.GENDER,
        eventTeamHeader.gender === "F" ? "Female" : "Male"
      );
    }

    // Replace age group placeholder if available
    if (eventTeamHeader.ageGroup && eventTeamHeader.ageGroup.name) {
      teamName = teamName.replace(
        TEAM_NAME_FORMAT_TYPES.AGE_GROUP,
        eventTeamHeader.ageGroup.name
      );
    } else {
      teamName = teamName.replace(TEAM_NAME_FORMAT_TYPES.AGE_GROUP, "");
    }
  }

  // Smart placeholder removal - remove placeholders and clean up surrounding spaces
  teamName = teamName.replace(
    new RegExp(`\\s*${TEAM_NAME_FORMAT_TYPES.AREA}\\s*`, "g"),
    " "
  );
  teamName = teamName.replace(
    new RegExp(`\\s*${TEAM_NAME_FORMAT_TYPES.CLUB}\\s*`, "g"),
    " "
  );
  // Clean up any remaining placeholders and trim whitespace
  return teamName
    .replace(TEAM_NAME_FORMAT_TYPES.AREA, "")
    .replace(TEAM_NAME_FORMAT_TYPES.CLUB, "")
    .replace(/\s+/g, " ") // Collapse multiple spaces to single space
    .trim();
}

/**
 * Helper function to get event team options from event header
 */
function getEventTeamOptions(eventTeamHeader: IEventTeamHeader): IEventTeam {
  if (eventTeamHeader.ceoptions && eventTeamHeader.ceoptions.eventTeam) {
    return eventTeamHeader.ceoptions.eventTeam;
  }
  return eventTeamHeader.eoptions.eventTeam;
}
